<template>
  <div class="trialSheetDataPage">
  <Header :page="pageTitle"></Header>
  <div class="bg">
    <div class="content-box">
    <el-table
      class="table"
      ref="dragTable"
      :data="dataList"
      v-loading="loading"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      border
      width="100%"
      fit
      :header-cell-style="{
        background: '#ECF2FE',
        borderColor: '#999999',
      }"
      :cell-style="{
        borderColor: '#999999',
      }"
    >
      <el-table-column
        align="center"
        v-for="headerItem in headerTitleList"
        :key="headerItem"
        :width= "cellWidth(headerItem)"
      >
        <template #header>
          <div v-if="headerItem.title == 'TYPE'">
            <el-dropdown trigger="click" :hide-on-click="false" @visible-change="dropdownChange" :disabled="!isSheetType">
              <div class="type-btn">{{ headerItem.title }}<i :class="typeIcon" v-show="isSheetType"></i></div>
              <template #dropdown>
                <el-dropdown-menu >
                  <el-dropdown-item v-for="m in tagsList" :key="m">
                    <el-checkbox v-model="m.selected" @change="checkChange(m)">{{ m.title }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div v-else class="header-title">{{ headerItem.title }}</div>
        </template>
        <template #default="scope">
          <div class="table-other" v-if="headerItem.title == 'ENV'">
            <div class="table-other-header" v-if="scope.row.envList.length > 0">
              <p v-for="env in scope.row.showEnvList" :key="env">{{ env }}</p>
            </div>
            <div class="table-other-header" v-else> / </div>
            <div class="img-box" v-if="showFold(scope.row.envList)" @click="showEnvDo(scope.row)">
              {{ isFold(scope.row.showEnvList) ? 'unfold' : 'fold' }}<img :src="isFold(scope.row.showEnvList) ? require('@/assets/unfold-icon.png') : require('@/assets/fold-icon.png') "/>
            </div>
          </div>
          <div class="trial-bg" v-else-if="headerItem.title == 'TRIAL'">
            <el-checkbox
              @mousedown="mouseDownCheckBox"
              @mouseover="mouseOverCheckBox(scope.row)"
              v-model="scope.row.isSelected"
              v-show="isShowCheckBox"
              @change="changeDo(scope.row)"
              class="checkBox"
            >
            </el-checkbox>
            <div class="table-trial">
              <a :href="scope.row.trial" target="_blank" @click="linkDo(scope.row)" :style="{color: scope.row?.color}">{{
                scope.row.trial
              }}</a>
            </div>
          </div>
          <div class="table-other" v-else>
            {{
              scope.row[headerItem.value] ? scope.row[headerItem.value] : "/"
            }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-bg">
      <div class="page-left">共 {{ totalCount }} 项数据</div>
      <el-pagination
        class="page-right"
        background
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="pageSie"
        :current-page="currentPage"
        @current-change="currentDo"
      >
      </el-pagination>
    </div>

    <img
      class="compare-trial-icon"
      id="divId"
      src="@/assets/sheet-compare-icon.png"
      @click="compareTrialDo"
      v-show="showCompareIcon"
    />
    </div>
    </div>
  </div>
</template>
<script>
import { queryResourcesList } from "@/request/api";
import Header from "@/components/Header.vue";
import { BenchMarkType } from "@/utils/common"
import {
  ResourceType,
  RunnerStatus,
} from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
import moment from "moment";
const NORMAL_ENV_COUNT = 3
export default {
  name: "trialSheetDataPage",
  data() {
    return {
      allDataList: [],
      headerTitle: "TRIAL",
      headerTitleList: [],
      currentPage: 1,
      pageSie: 5,
      pageTitle: "data",
      isShowCheckBox: false,
      moveOverItem: {},
      selectTrialList: [],
      selectTags: [],
      resourceType: ResourceType.DATA,
      curType: "",
      tagsList:[],
      typeIcon: "el-icon-arrow-up",
      loading: true,
      totalCount: 0,
    };
  },

  watch: {
    $route(to, from) {
      if (to.fullPath != from.fullPath) {
        this.createData();
      }
    },
  },
  components: {
    Header,
  },
  computed: {
    //收缩
    isFold() {
      return (list => {
        return list?.length <= NORMAL_ENV_COUNT 
      })
    },
    showFold() {
      return (list => {
        return list?.length > NORMAL_ENV_COUNT 
      })
    },
    cellWidth() {
      return (item => {
        const title = item?.title 
        if (title == "TRIAL") {
          return this.isShowCheckBox ? 520 : 505
        } else if (title == "TYPE") {
          return 110
        }
        return 0
      })
    },
    isSheetType() {
      const type = this.$route.params.index;
      return type == BenchMarkType.Sheet
    },
    dataList() {
      const type = this.$route.params.index;
      if (type == BenchMarkType.Sheet) {
        const list = this.allDataList.slice(
          this.pageSie * (this.currentPage - 1),
          this.pageSie * this.currentPage
        );
        return list
      }

      const list = this.allDataList.filter(m => {
        return m.key == this.currentPage
      })
      return list.shift()?.list;
      
    },
    showCompareIcon() {
      const ll = this.selectTrialList.filter((m) => {
        return m.isSelected == true;
      });
      return ll.length >= 2
    },
   
  },
  methods: {
    linkDo(row) {
      for (const model of this.dataList) {
        if (model.no == row.no) {
          model.color = "#000"
        } else {
          model.color = ""
        }
      }
    },
    showEnvDo(row) {
      for (const model of this.dataList) {
        if (model?.envList?.length > NORMAL_ENV_COUNT) {
          if (model.no == row.no) {
            if (model?.showEnvList?.length <= NORMAL_ENV_COUNT) {
              model.showEnvList = model?.envList
            } else {
              model.showEnvList = model?.envList.slice(0, NORMAL_ENV_COUNT)
            }
          } else {
            model.showEnvList = model?.envList.slice(0, NORMAL_ENV_COUNT)
          }
        } else {
          model.showEnvList = model?.envList
        }
      }
    },
    dropdownChange(drop) {
      if (drop) {
        this.typeIcon = "el-icon-arrow-down"
      } else {
        this.typeIcon = "el-icon-arrow-up"
      }
    },
    checkChange(m) {
      console.log(m)
      this.selectTags = []
      this.tagsList.forEach(item => {
        if (item.selected) {
          this.selectTags.push(item.title)
        }
      });
      this.selectTrialList = []
      this.allDataList = []
      this.currentPage = 1
      this.getResourceData();
    },
    changeDo(model) {
      if (model.isSelected) {
        if (this.selectTrialList.length >= 2) {
          model.isSelected = false
          return
        }
        this.selectTrialList.push(model)
      } else {
        const index = this.selectTrialList.indexOf(model)
        this.selectTrialList.splice(index, 1)
      }
    },
    compareTrialDo() {
      if (this.selectTrialList.length >= 2) {
        const id = this.selectTrialList[0].trialid
        const cid = this.selectTrialList[1].trialid
        const routeData = this.$router.resolve({
          name: "SheetComparePage",
          params: { id: id, cid: cid },
        });
        window.open(routeData.href, "_blank");    
      } else {
        this.$message.warning("You must select two sheets")
      }
    },
    mouseOverCheckBox(item) {
      this.moveOverItem = item;
    },
    mouseDownCheckBox(e) {
      if (this.selectTrialList.length >= 2) {return}
      if (!this.moveOverItem.isSelected) {
        this.isShowCompareIcon = true;
        const d = document.getElementById("divId");
        d.style.left = 8 + "px";
        d.style.top = e.pageY - 155 + "px";
      } 
    },
    currentDo(index) {
      this.currentPage = index;
      const type = this.$route.params.index;
      if (type == BenchMarkType.Sheet) {
        return
      }
      this.getResourceData();
    },
    createData() {
      const params = this.$route.params;
      const page = params.index;
      this.pageTitle = page;
      console.log("screen.availHeight = ", screen.availHeight);
      this.pageSie = screen.availHeight <= 875 ? 5 : 10;
      this.currentPage = 1;

      this.selectTrialList = []
      this.allDataList = []

      this.getAllDataList();
    },
    getStatusTitle(status) {
      let statusTitle = "";
      if (status == RunnerStatus.DONE) {
        statusTitle = "Done";
      } else if (status == RunnerStatus.ERROR) {
        statusTitle = "Error";
      } else if (status == RunnerStatus.RUNNING) {
        statusTitle = "Running";
      } else if (status == RunnerStatus.WAITING) {
        statusTitle = "Waiting";
      } else if (status == RunnerStatus.TIMEOUT) {
        statusTitle = "Timeout";
      } else if (status == RunnerStatus.CANCELED) {
        statusTitle = "cancelled";
      }
      return statusTitle;
    },
    async getResourceData() {
      let tagsArr = []
      let resourcesList = []
      this.loading = true
      const pageNumber = this.currentPage - 1
      const type = this.$route.params.index;
      if (type == BenchMarkType.Sheet) {
        if (this.selectTags.length > 0) {
          const hasNone = this.selectTags.some(tag => {
            return tag == "None"
          })
          if (hasNone) {
            tagsArr = this.selectTags.filter(tag => {
              return tag != "None"
            })
            if (tagsArr.length >= 1) {
              try {
                const resourceObj = await queryResourcesList({type: this.resourceType, tags: tagsArr});
                resourcesList = resourceObj.resourcesList
              } catch (error) {
                this.loading = false
              }
            } 
            const resourceObj = await queryResourcesList({type: this.resourceType});
            
            const resourcesNoneList = resourceObj.resourcesList
            const noneList = resourcesNoneList.filter(res => {
              return res?.tagsList?.length <= 0
            })
            resourcesList = resourcesList.concat(noneList)
            this.totalCount = resourcesList.length
            resourcesList.sort((m1, m2) => {
              return m2?.creationtime?.seconds - m1?.creationtime?.seconds
            })
            
          } else {
            tagsArr = this.selectTags
            try {
              const resourceObj = await queryResourcesList({type: this.resourceType, tags: tagsArr, pageNumber: pageNumber, pageSize: this.pageSie});
              this.totalCount = resourceObj.totalcount
              resourcesList = resourceObj.resourcesList
            } catch (error) {
              this.loading = false
            }
          }
        } else {
          resourcesList = []
        }
      } else {
        const modelList = this.allDataList.filter(model => {
          return model.key == this.currentPage
        })
        if (modelList?.length > 0) {
          this.loading = false
          return
        }
        try {
          let isOwner = true
          if (type == BenchMarkType.Tigris) {
            tagsArr = ['Tigris']
            isOwner = false
          }
          const resourceObj = await queryResourcesList({type: this.resourceType, tags: tagsArr, pageNumber: pageNumber, pageSize: this.pageSie}, isOwner);
          this.totalCount = resourceObj.totalcount
          resourcesList = resourceObj.resourcesList
        } catch (error) {
          this.loading = false
        }
      }
      this.loading = false
      this.getPageData(resourcesList)
    },

    getPageData(resourcesList) {
      const newList = []
      const href = window.location.href.split("/benchmark").shift();
      for (const index in resourcesList) {
        const no = parseInt(index) + 1;
        const item = resourcesList[index]
        const owner = item.owner
        const trialid = item.resourceid;
        const trial = href + `/benchmark/${this.curType}/` + item.resourceid;
        const createDate = moment(
          (item.creationtime?.seconds +
            item.creationtime?.nanos / Math.pow(10, 9)) *
            1000
        ).format("YYYY-MM-DD HH:mm:ss");
        const status = this.getStatusTitle(item.runnerstatus);
        const retention = item.retention == 0 ? "ShortLived" : "LongLived";
        let tag = ""
        if (item?.tagsList?.length > 0) {
          tag = item.tagsList.join("\n")//item.tagsList[0]
        }
        const isSelected = false;
        let title = "";
        let describle = "";
        let env = ""
        let envList = []
        for (const map of item.annotationsMap) {
          if (map[0]?.trim().toLocaleLowerCase() == "title") {
            title = map[1];
          } else if (map[0]?.trim().toLocaleLowerCase() == "description") {
            describle = map[1];
          } else if (map[0]?.trim().toLocaleLowerCase() == "env") {
            if (map?.length >= 2) {
              const nevStr1 = map[1]
              const nevStr2 = nevStr1.replace(/:/g, "=")
              console.log(nevStr2)
              if (nevStr2.includes(";")) {
                const arr = nevStr2.split(";")
                for (const a of arr) {
                  envList.push(a)
                  const str = a + "\n"
                  env += str;
                }
              }
            }
          }
        }
        let showEnvList = []
        if (envList.length >= NORMAL_ENV_COUNT) {
          showEnvList = envList.slice(0, NORMAL_ENV_COUNT)
        } else {
          showEnvList = envList
        }
        const model = {
          no,
          trial,
          createDate,
          status,
          retention,
          isSelected,
          title,
          describle,
          trialid,
          env,
          tag,
          owner,
          envList,
          showEnvList,
        };
        newList.push(model);
      }
      const type = this.$route.params.index;
      if (type == BenchMarkType.Sheet) {
        this.allDataList = newList
      } else {
        this.allDataList.push({
          key: this.currentPage,
          list: newList
        })
      } 
    },

    async getAllDataList() {
      const type = this.$route.params.index;
      this.headerTitleList = [
        {
          title: "TRIAL",
          value: "trial",
        },
        {
          title: "CREATEDAT",
          value: "createDate",
        },
        {
          title: "STATUS",
          value: "status",
        },
        {
          title: "RETENTION",
          value: "retention",
        },
        {
          title: "TITLE",
          value: "title",
        },
        {
          title: "DESCRIPTION",
          value: "describle",
        },
      ];
      this.isShowCheckBox = false;
      let title = ""
      if (type == BenchMarkType.Data) {
        this.resourceType = ResourceType.DATA;
        this.headerTitle = BenchMarkType.Data.toLocaleUpperCase();
        title = BenchMarkType.Data
        this.headerTitleList.splice(2, 1);
        this.curType = BenchMarkType.Data
      } else if (type == BenchMarkType.Trial) {
        this.resourceType = ResourceType.TRIAL;
        this.headerTitle = BenchMarkType.Trial.toLocaleUpperCase();
        title = BenchMarkType.Trial
        this.curType = BenchMarkType.Trial
      } else if (type == BenchMarkType.Sheet || type == BenchMarkType.Tigris) {
        this.isShowCheckBox = true;
        this.resourceType = ResourceType.SHEET;
        this.headerTitle = BenchMarkType.Sheet.toLocaleUpperCase();
        this.headerTitleList.splice(2, 1);
        title = BenchMarkType.Sheet
        this.curType = BenchMarkType.Sheet
        this.headerTitleList.push({title: "ENV", value: "env"})
        if (type == BenchMarkType.Tigris) {
          title = BenchMarkType.Tigris
          this.headerTitle = title.toLocaleUpperCase();
          this.headerTitleList.push({title: "Owner", value: "owner"})
        }
        this.headerTitleList.push({title: "TYPE", value: "tag"})
      }
      document.title = `aqua.${title}list`
      this.getResourceData()
    },
    //错位
    tableLayout() {
      this.$nextTick(() => {
        this.$refs.dragTable.doLayout();
      });
    },
  },
  created() {
    this.tagsList = [... this.$DataString.tagList]
    this.tagsList.push({
      "title": "None",
      "selected": true
    })
    this.tagsList.forEach(model => {
      model.selected = true;
      this.selectTags.push(model.title);
    })
    this.tableLayout();
    this.createData();
  },
};
</script>
<style lang='less' scoped>
.trialSheetDataPage {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.bg {
  padding: 35px 90px 10px 90px;
  background-color: #f5f5f5;
}
.content-box {
  padding: 35px 53px;
  position: relative;
  background-color: #ffffff;
  border-radius: 3px;
  position: relative;
}
.table {
  width: 100%;
  border: 1px solid #999999;
  // height: 631px;
}

.compare-trial-icon {
  position: absolute;
  height: 35px;
  width: 35px;
  top: 90px;
  left: 300px;
  z-index: 99;
  object-fit: contain;
  cursor: pointer;
}

.header-title {
  // height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 15px;
  font-weight: bold;
  // padding: 0px 8px;
  display: flex;
  word-break: break-all;
}

.type-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ECF2FE;
  border: 0px;
  color: #000000;
  font-size: 15px;
  font-weight: bold;
  padding: 5px 10px;
  user-select: initial;
  cursor: pointer;
}

.trial-bg {
  display: flex;
  align-items: center;
  padding: 10px 0px 10px 5px;
  .checkBox {
    margin-right: 8px;
  }

  .table-trial {
    display: flex;
    text-align: left;
    // margin-left: 18px;
    color: #383838;
    font-size: 14px;
    font-weight: 400;

    a {
      display: flex;
      text-decoration: none;
      font-size: 14px;
      font-weight: 400;
      color: #0052d9;
    }
  }
}

.table-other {
  display: flex;
  flex-direction: column;
  .table-other-header {
    display: flex;
    flex-direction: column;
    p {
      color: #383838;
      font-size: 14px;
      font-weight: 400;
      width: 100%;
      display: flex;
      word-break: break-all;
      align-items: center;
      justify-content: center;
      // white-space: pre-wrap;
    }
  }
  .img-box {
    display: flex;
    justify-content: flex-end;
    font-size: 11px;
    color: #0052d9;
    align-items: center;
    cursor: pointer;
    img {
      margin-left: 1px;
      width: 11px;
      object-fit: contain;
    }
  }
}
.page-bg {
  display: flex;
  // height: 35px;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px 0px 20px;
  margin-top: 20px;
  .page-left {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }
}
:deep(.el-table th) {
  user-select: initial !important;
}

.el-dropdown-menu__item {
  width: 110px !important;
  padding: 0px 0px 0px 11px !important;
}
</style>